export default __webpack_public_path__ + "static/media/icon_only_small-removebg.3d16ce0d.png";